import type { InspectionStatus, InspectionType } from '@/common/inspection';
import type { Pagination } from '@/common/pagination';
import { checkAssetIdIsValid } from '@/lib/utils/asset';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type InspectionListSuccessResponseType = {
	inspections: InspectionType[];
	total: number;
	limit: number;
	offset: number;
};

export type InspectionQueryParams = Pagination & {
	/** Allowlisted `field:asc|desc` pairs, see INSPECTION_SORT_FIELDS in the backend DTO. */
	sort?: string;
	/** Only inspections with this status */
	status?: InspectionStatus;
	/** Only deleted inspections (needs INSPECTIONS_DELETE) */
	deleted?: boolean;
};

async function getListInspections(
	assetId: string,
	query: InspectionQueryParams,
): Promise<InspectionListSuccessResponseType | null> {
	const response = await axios.get(`${API_URLS.INSPECTION.INDEX(assetId)}`, {
		params: query,
	});
	return getResponse<InspectionListSuccessResponseType>(response.data);
}

export function useQueryListInspectionsOptions(assetId: string, query: InspectionQueryParams, enabled = true) {
	const isValidAssetId = checkAssetIdIsValid(assetId);
	return {
		queryKey: ['assets', assetId, 'inspections', query],
		queryFn: () => getListInspections(assetId, query),
		enabled: enabled && isValidAssetId,
	};
}
